import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * A text field. The border uses the input token, which clears 3:1 on every surface. Disabled is a
 * flat muted fill, never a reduced opacity.
 */
function Input({ className, type = "text", ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full min-w-0 rounded-md border border-input bg-card px-3 text-sm text-foreground transition-colors outline-none",
        "placeholder:text-muted-foreground hover:border-foreground/45",
        "focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ring",
        "disabled:cursor-not-allowed disabled:border-border disabled:bg-muted disabled:text-muted-foreground",
        "read-only:bg-muted/50 read-only:text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
